/*
 * Project: BookingEngine
 * Module: components/booking/hotels/Hotels.js
 * vim:ft=javascript.jsx:
 * @flow
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setFormVisible } from 'bookingform';

import Hotel from './Hotel';
import MinimumStaysCalendar from './MinimumStaysCalendar';

import { getNearbyHotels } from '../../../actions/Booking';
import { CALL_CENTER_ROLE } from '../../../constants';

import '../../../static/less/hotel/hotels.less';
import sandosLogo from '../../../static/images/SANDOS_logo_lg.png';
import marconfortLogo from '../../../static/images/MARCONFORT_logo_lg.png';
import palmaiaLogo from '../../../static/images/PALMAIARESORTS_logo_lg.png';
import withNavigate from '../../../withNavigate'; // Importa el HOC

const chainLogos = {
  SANDOS: sandosLogo,
  MARCONFORT: marconfortLogo,
  PALMAIARESORTS: palmaiaLogo,
};

class Hotels extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isLoading: false, hasResults: true };
  }

  componentDidMount() {
    const info = this.props.requestedInfo;
    if (!info || !info.hotels || info.hotels.length === 0) {
      this.props.navigate('/');
      return;
    }
    const {
      requestedInfo, isFreeModeSelected, destType, zoneAvailHotels,
    } = this.props;
    if (!isFreeModeSelected && !zoneAvailHotels) {
      const hotelCode = requestedInfo.hotels[0];
      this.getNearbyHotelsResult(hotelCode);
    } else if (destType === 'zone' && zoneAvailHotels) {
      this.props.setFormVisible(true);
    }
  }

  getNearbyHotelsResult(hotelCode) {
    this.setState({ isLoading: true });
    this.props.getNearbyHotels(hotelCode).then((hasResults) => {
      this.setState({ isLoading: false, hasResults });
      this.props.setFormVisible(true);
    });
  }

  showResultsMessage() {
    if (this.state.hasResults) {
      return <h2>{this.context.t('Please check our other hotels - the hotel you requested has no availability')}</h2>;
    }
    // In this case, we will have made the form visible so they can try a new search
    return <h2 className="warning">{this.context.t('Sorry, no availability was found in nearby hotels')}</h2>;
  }

  render() {
    const { destType, zoneAvailHotels } = this.props;
    if (this.state.isLoading && !zoneAvailHotels) {
      return (
              <div className="row Search">
                <div className="col-md-12">
                  <img src={chainLogos[this.props.chain]} className="logo"/>
                  <div className="loader-sandos">
                    {this.context.t('Loading')}...
                  </div>
                  <h1>{this.context.t('We are checking availability in nearby hotels')}</h1>
                  {this.context.t('Sorry, the hotel you requested has no availability')}
                </div>
              </div>
      );
    }

    // If the search has been launched by a call center used using the "FreeMode",
    // we can not search nearby hotels, but we can show the minimum stays calendar.
    if (this.props.isFreeModeSelected && this.props.isCallCenterUser) {
      return (
              <MinimumStaysCalendar
                      hotelCode={this.props.requestedInfo.hotels[0]}
                      checkIn={this.props.checkIn}
              />
      );
    }

    const info = this.props.requestedInfo;
    if (!this.props.nearbyHotels && !zoneAvailHotels) {
      return null;
    }
    const hotels = this.props.nearbyHotels || zoneAvailHotels || [];
    return (
            // eslint-disable-next-line react/no-string-refs
            <div className="hotel-alternative" ref="Hotels">
              <header className="py-4">
                {destType === 'zone'
                  ? (<h1>{this.context.t('Availability in hotels')}</h1>)
                  : (<h1>{this.context.t('Availability in other hotels')}</h1>)
                }
                {destType !== 'zone' && this.showResultsMessage()}
              </header>
              <div className="row hotel-list">
                {hotels.map((hotel) => (
                        <Hotel hotel={hotel} info={info} key={hotel.code}/>
                ))}
              </div>
            </div>
    );
  }
}

Hotels.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

Hotels.contextTypes = {
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  chain: state.bookingFormState.chain,
  checkIn: state.bookingFormState.checkIn,
  hotel: state.bookingFormState.destination,
  destType: state.bookingFormState.destType,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  isFreeModeSelected: state.bookingFormState.isFreeModeSelected,
  nearbyHotels: state.booking.nearbyHotels,
  zoneAvailHotels: state.booking.zoneAvailHotels,
  requestedInfo: state.booking.last_requested_info,
});

const mapDispatchToProps = (dispatch) => ({
  setFormVisible: (payload) => dispatch(setFormVisible(payload)),
  getNearbyHotels: (payload) => dispatch(getNearbyHotels(payload)),
});

const ConnectedHotels = connect(mapStateToProps, mapDispatchToProps)(Hotels);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedHotels);
